enum SocketServerEvents {
  receivedMessage = "receivedMessage",
  joinedRoom = "joinedRoom",
  messageWasRead = "messageWasRead",
  notification = "notification",
  roomCreated = "roomCreated",
  refresh = "refresh",
  myError = "myError",
}

export default SocketServerEvents;
